import { ClipboardList, Users, Store, Radar, Map as MapIcon, BarChart3 } from "lucide-react";
import DashboardShell from "@/components/DashboardShell";

const NAV = [
  { label: "Applicants", to: "/admin", icon: ClipboardList, end: true },
  { label: "Drivers", to: "/admin/drivers", icon: Users },
  { label: "Merchants", to: "/admin/merchants", icon: Store },
  { label: "Dispatch", to: "/admin/dispatch", icon: Radar },
  { label: "Regions", to: "/admin/regions", icon: MapIcon },
  { label: "Reports", to: "/admin/reports", icon: BarChart3 },
];

export default function AdminLayout() {
  return <DashboardShell roleTag="Operations Console" navItems={NAV} />;
}
